import React from 'react';
import './style.css';

const IndicadorDocumento = ({ children }) => {
    return <div className="indicador_documento">{children}</div>;
};

export { IndicadorDocumento };
